<template>
    <ion-item
        :key="jobsite.id"
        :class="{
                    jobsiteItem: true,
                    unselected: props.selectable && !props.selected,
                    removed: (showDisabledEffectivelySubtitle && jobsite.disabledEffectively) || (showClientPreventedSubtitle && jobsite.isClientPreventedJobsite) || (showBlacklistedCategorySubtitle && jobsite.isBlacklist),
                    disabled: disabled
                }"
        @click="() => { emit('select', jobsite) }"
    >

        <JobsiteDemandIndicator
            v-if="!selectable"
            :demandIndicatorLevel="jobsite.demandIndicator"
            slot="start"
            style="height: 3.75rem; width: 0.5rem;"
        />

        <ion-label>
            <h3 class="title">{{ jobsiteListTitle(jobsite) }} </h3>
            <p class="subtitle"> {{jobsiteListSubtitle(jobsite, true)}} </p>

            <p v-if="showJobsiteCategorySubtitle && jobsite.isFavorite"> <IonIcon :icon="KapitelIcon.favoriteJobsite" class="globalTextAlignedIcon" color="primary"></IonIcon> {{getLabelForJobsiteCategory(JobsiteCategory.Favorite, false)}}</p>
            <p v-else-if="showJobsiteCategorySubtitle && jobsite.isAlternative"> <IonIcon :icon="KapitelIcon.alternativeJobsite" class="globalTextAlignedIcon" color="primary"></IonIcon> {{getLabelForJobsiteCategory(JobsiteCategory.Alternative, false)}}</p>
            <p v-else-if="showJobsiteCategorySubtitle && jobsite.isBooked"> <IonIcon :icon="KapitelIcon.booking" class="globalTextAlignedIcon" color="primary"></IonIcon> Schon einmal gebucht</p>

            <p v-if="showBlacklistedCategorySubtitle && jobsite.isBlacklist"> <IonIcon :icon="KapitelIcon.blockedJobsite" class="globalTextAlignedIcon" color="primary"></IonIcon> Station über Stationsverwaltung gesperrt</p>

            <p v-if="showClientPreventedSubtitle && jobsite.isClientPreventedJobsite" class="">
                <IonIcon :icon="KapitelIcon.warning" class="globalTextAlignedIcon" color="primary"/>
                Station kundenseitig gesperrt.
            </p>
            <p v-if="showDisabledEffectivelySubtitle && jobsite.disabledEffectively" class="">
                <IonIcon :icon="KapitelIcon.warning" class="globalTextAlignedIcon" color="primary"/>
                Station deaktiviert.
            </p>
        </ion-label>

        <ion-radio
            v-if="selectable"
            :aria-label="jobsiteListTitle(jobsite)"
            slot="start"
            :checked="selected"
            label-placement="end"
            justify="start"
        />

        <ion-button
            slot="end"
            class="jobsiteInfo"
            fill="clear"
            :color="selectable ? 'secondary' : ''"
            @click.stop="emit('info', jobsite)"
        >
            <ion-icon
                slot="icon-only"
                :icon="selectable ? KapitelIcon.info : KapitelIcon.infoFill"
            />
        </ion-button>
    </ion-item>
</template>

<script setup lang="ts">
import {IonButton, IonIcon, IonItem, IonLabel, IonRadio,} from '@ionic/vue'
import {PropType} from 'vue'
import {jobsiteListSubtitle, jobsiteListTitle,} from "@/helper/jobsite"
import {KapitelIcon} from "@/helper/icon";
import {JobsiteWithEmployeeFlagsFragment} from "@/graphql/generated/graphql";
import JobsiteDemandIndicator from "@/views/components/JobsiteDemandIndicator.vue";
import {getLabelForJobsiteCategory} from "@/helper/jobsiteCategory";
import {JobsiteCategory} from "@/graphql/kapitelTypes";


const props = defineProps({
    jobsite: {
        type: Object as PropType<JobsiteWithEmployeeFlagsFragment>,
        required: true
    },
    // checkbox & checkbox state
    selectable: Boolean,
    selected: Boolean,

    // greyed out, events still emitted
    disabled: Boolean,

    // indicate favorite, alternative or booked
    showJobsiteCategorySubtitle: Boolean,

    // indicate blacklisted (name also striked through)
    showBlacklistedCategorySubtitle: {
        type: Boolean,
        default: true,
    },

    // indicate blacklisted (also striked through)
    showClientPreventedSubtitle: {
        type: Boolean,
        default: true,
    },

    // indicate blacklisted (also striked through)
    showDisabledEffectivelySubtitle: {
        type: Boolean,
        default: true,
    },
})

const emit = defineEmits(['select', 'info'])

</script>

<style lang="scss" scoped>

.removed h3 {
    text-decoration: line-through;
}


.jobsiteItem {
    ion-checkbox {
        width: 75%;
    }

    ion-button.jobsiteInfo {
        position: fixed;
        right: 0px;
    }

    &.unselected ion-label {
        opacity: 0.75;
    }
}

ion-item.jobsite-item-client-prevented {
    --color: var(--ion-color-medium);
}


.disabled ion-label>*:not(.ignoreDisabled) {
    opacity: 0.25;
}
</style>
